import { render, staticRenderFns } from "./DynamicsDetails.vue?vue&type=template&id=d2044aaa&scoped=true"
import script from "./DynamicsDetails.vue?vue&type=script&lang=js"
export * from "./DynamicsDetails.vue?vue&type=script&lang=js"
import style0 from "./DynamicsDetails.vue?vue&type=style&index=0&id=d2044aaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2044aaa",
  null
  
)

export default component.exports